import { useMediaQuery } from "react-responsive";
import React, { FC, useMemo } from "react";
import classNames from "classnames/dedupe";
import isWhiteColor from "../../../helpers/isWhiteColor";
import { IColorPickerProps, TProductColor } from "./ColorPicker.interface";

const DISPLAY_AMOUNT_MOBILE = 3;
const DISPLAY_AMOUNT_DESKTOP = 5;
const MAX_WIDTH_MOBILE = 768;

export const KNOWN_COLORS: TProductColor[] = [
  "black",
  "white",
  "red",
  "green",
  "gray",
];

const ColorPicker: FC<IColorPickerProps> = ({
  colors,
  maxOnMobile = DISPLAY_AMOUNT_MOBILE,
  maxOnDesktop = DISPLAY_AMOUNT_DESKTOP,
  maxWidthMobile = MAX_WIDTH_MOBILE,
}) => {
  const isMobile = useMediaQuery({ query: `(max-width: ${maxWidthMobile}px)` });
  const colorsToRender = useMemo(
    () => colors.slice(0, maxOnDesktop),
    [colors, maxOnDesktop],
  );
  const colorsWithIDs = useMemo(
    () => colorsToRender.map((color, index) => ({ id: color + index, color })),
    [colorsToRender],
  );

  const itemsNumber: number = isMobile ? maxOnMobile : maxOnDesktop;

  const colorsLeft = useMemo(
    () => colors.slice(itemsNumber, colors.length).length,
    [colors, itemsNumber],
  );
  const displayColors = colorsWithIDs.map(({ color, id }) => {
    /** check white colors (needs gray border) */
    const currentColor = isWhiteColor(color) ? "white" : color;
    return (
      <li
        key={id}
        className={classNames(
          "colors-list__item",
          KNOWN_COLORS.includes(currentColor as TProductColor)
            ? currentColor
            : "",
        )}
        data-testid="display-color__TestID"
        style={
          KNOWN_COLORS.includes(currentColor as TProductColor)
            ? undefined
            : { backgroundColor: currentColor }
        }
      />
    );
  });

  const moreColors =
    colors?.length > itemsNumber ? (
      <div className="colors-list__more-item">
        <span>+{colorsLeft}</span>
      </div>
    ) : null;

  return (
    colors && (
      <ul className="colors-list" data-testid="color-list__TestID">
        {displayColors}
        {moreColors}
      </ul>
    )
  );
};

export default ColorPicker;
